import { useUtilisateurService } from '@europrocurement/l2d-domain';
import { UserJsonld } from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';
import { useCallback, useState } from 'react';

export const useUser = () => {
    const [cache, setCache] = useState<Record<string, UserJsonld | null>>({});
    const [pendingPromises, setPendingPromises] = useState<
        Record<string, Promise<UserJsonld | null>>
    >({});
    const { userKeycloakApi } = useUtilisateurService();

    const fetchUser = useCallback(
        async (userIdentifier: string): Promise<UserJsonld | null> => {
            if (!userIdentifier) return null;
            if (cache[userIdentifier]) {
                return cache[userIdentifier];
            }
            if (pendingPromises[userIdentifier]) {
                return pendingPromises[userIdentifier];
            }
            const userPromise = userKeycloakApi
                .apiKeycloakUtilisateursIdidentityGet({
                    id: userIdentifier,
                })
                .then(async (response) => {
                    const user = await response.data;
                    setCache((prev) => ({ ...prev, [userIdentifier]: user }));
                    return user;
                })
                .catch((error) => {
                    console.error('Erreur:', error);
                    setCache((prev) => ({ ...prev, [userIdentifier]: null }));
                    return null;
                })
                .finally(() => {
                    setPendingPromises((prev) => {
                        const newPending = { ...prev };
                        delete newPending[userIdentifier];
                        return newPending;
                    });
                });

            setPendingPromises((prev) => ({ ...prev, [userIdentifier]: userPromise }));

            return userPromise;
        },
        [cache, pendingPromises, userKeycloakApi],
    );

    return { fetchUser, cache };
};
